import React, { useContext } from 'react'
import { AvailabilityPageContainer } from 'src/mentor/components/MentorAvailabilityPage/MentorAvailabilityPageStyles'
import MentorHeader from 'src/mentor/components/MentorHeader'
import { MentorProfileContext } from 'src/mentor/context/MentorProfileContext'
import { getDataMapFromCommonResponse } from 'src/mentor/helpers/utilityFunctions'
import InvoiceListing from 'src/supportPortal/views/payoutReports/InvoiceListing'

export default function MentorPayoutInvoices() {
  const { mentorProfileData } = useContext(MentorProfileContext)

  function prepareBookedEventsDataFromApiResponse(response) {
    const data = getDataMapFromCommonResponse(response)
    const bookedEvents = data?.['booked-event-info']
    return bookedEvents
  }

  return (
    <AvailabilityPageContainer>
      <MentorHeader heading={`Your Payout Invoices`} />
      <InvoiceListing
        entityListOverride={[mentorProfileData]}
        hideActions
        hidePaymentStatusFilter
        hideTargetEntityIdFilter
        invoicesListingApiSignature="/api/secure/mentor/payout-invoice/paginated"
        bookedEventsListingApiSignature="/api/secure/mentor/payout-invoice/booked-events"
        targetEntityType="mentor"
        prepareBookedEventsDataFromApiResponse={prepareBookedEventsDataFromApiResponse}
        initialFilters={{
          targetEntityIds: mentorProfileData?.id,
          targetEntityTypes: 'mentor',
        }}
      />
    </AvailabilityPageContainer>
  )
}
